module.exports = __webpack_public_path__ + "media/Video 118.dae87ce7.mp4";